import { Tooltip } from '@healingpaper/cell'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IcQuestionCircle } from '@healingpaper/cell-icons'

export const ReplyTooltip = () => {
  const { t } = useTranslation()
  const [isReplyTooltipVisible, setIsReplyTooltipVisible] = useState(false)

  return (
    <div className="[&_div[role=tooltip]]:top-8 [&_div[role=tooltip]]:-left-[14px] [&_div[role=tooltip]]:min-w-[200px] [&_div[role=tooltip]]:max-w-[211px] [&_div[role=tooltip]_*]:inline cursor-pointer">
      <Tooltip
        showed={isReplyTooltipVisible}
        type="description"
        content={<div dangerouslySetInnerHTML={{ __html: t('pages.doctorDetail.tooltipContent') }} />}
        onClick={() => setIsReplyTooltipVisible((prev) => !prev)}
      >
        <IcQuestionCircle width="20" height="20" />
      </Tooltip>
    </div>
  )
}
